module.exports = __webpack_public_path__ + "static/media/sosyal.bacaa88d.svg";